<template>
  <div v-if="Object.keys(images).length">
    <div
      v-if="ownCdrFlag"
      class="alert alert-warning py-2 px-3 mb-2 d-flex align-items-center gap-2"
    >
      <i class="fas fa-exclamation-triangle" />
      <span>
        {{ trans("admin.cdr.flagBanner.heading") }} &mdash;
        {{ ownCdrFlag.reasonLabel }}
      </span>
    </div>
    <p>{{ examination.createdAt }}</p>
    <div
      class="patient-images-container justify-content-between align-items-end"
    >
      <div
        v-for="(image, key) in images"
        :key="key"
        class="patient-images-wrapper"
      >
        <label>{{ image.label }}</label>

        <div v-if="isVideo(image)" class="image-container">
          <video-thumbnail
            :thumbnail-url="getVideoThumbnailUrl(image)"
            @click="handleVideoClick(image)"
          />
        </div>

        <div v-else class="image-container" @click="handleImageClick(image)">
          <encoded-image
            :image-id="image.id"
            style-class="img-fluid zoom lightbox-thumbnail"
            :case-id="examination.id"
            :uri="image.uri"
            @on-receive-encoded-image="onEncodedImageLoaded"
          />
        </div>
      </div>
      <div class="align-self-end">
        <button class="btn btn-primary" @click="visitCase">
          {{ trans("examination.visitCase") }}
        </button>
      </div>
    </div>

    <portal to="lightbox-container">
      <Lightbox
        v-if="activeImage"
        v-model:activeImage="activeImage"
        :images="lightboxImages"
        @close-event="handleClose"
      />
    </portal>

    <VideoOverlay
      v-if="activeVideo"
      ref="videoPlayer"
      :src="getVideoUrl(activeVideo)"
      @close="handleVideoClose"
    />

    <div class="mx-2 my-3 border-bottom" />
  </div>
</template>

<script>
import ConsultationMedia from "../../AddOns/ConsultationMedia.vue";
import EncodedImage from "../../AddOns/EncodedImage.vue";
import MediaGallery from "../../AddOns/MediaGallery.vue";
import Lightbox from "../../../Layout/Lightbox.vue";
import VideoOverlay from "../../AddOns/VideoOverlay.vue";
import VideoThumbnail from "../../AddOns/VideoThumbnail.vue";

export default {
  components: {
    VideoThumbnail,
    VideoOverlay,
    ConsultationMedia,
    MediaGallery,
    EncodedImage,
    Lightbox,
  },
  props: {
    fields: Array,
    examination: Object,
  },
  data() {
    return {
      activeImage: false,
      activeVideo: false,
      encodedImages: {},
    };
  },
  computed: {
    ownCdrFlag() {
      return this.examination.pendingCdrFlags?.find((f) => f.isOwnFlag) ?? null;
    },
    images() {
      return this.examination.images || {};
    },
    lightboxImages() {
      return Object.values(this.images).map((image) => ({
        id: image.id,
        url: this.encodedImages[image.id] || image.uri,
      }));
    },
  },
  methods: {
    isVideo(image) {
      return image?.media_type === "video";
    },
    getVideoUrl(image) {
      return `/api/internal/${this.examination.id}/media/${image.id}/stream`;
    },
    getVideoThumbnailUrl(image) {
      return `/api/internal/${this.examination.id}/media/thumbnail/${image.id}/`;
    },
    handleVideoClick(image) {
      this.activeVideo = image;
    },
    handleImageClick(image) {
      this.activeImage = this.activeImage
        ? false
        : this.lightboxImages.find((img) => parseInt(img.id) === image.id);
    },
    handleVideoClose() {
      this.activeVideo = false;
    },
    handleClose() {
      this.activeImage = false;
    },
    onEncodedImageLoaded: function (event) {
      this.encodedImages = {
        ...this.encodedImages,
        [event.imageId]: event.uri,
      };
    },
    visitCase: function () {
      this.$router.push({
        path: `/consultations/${this.examination.product.url}/${this.examination.id}/edit`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.patient-images-container {
  display: flex;
  flex-direction: row;
  margin: 10px 0 10px 0;
}
.image-container {
  max-height: 100%;
  max-width: 200px;
  margin-right: 10px;
  overflow: hidden;
}

@media (max-width: 415px) {
  .patient-images-container {
    display: block;

    .btn.btn-primary {
      margin-top: 10px;
      width: 100%;
    }

    .patient-images-wrapper {
      margin-top: 10px;

      .image-container {
        width: 100%;
        height: auto;
        max-height: initial;
        max-width: initial;
      }
    }
  }
}
</style>
